import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Dashboard from './pages/Dashboard';
import HpSettingsPage from './pages/HpSettingsPage';
import ServiceListPage from './pages/ServiceListPage';
import NewServicePage from './pages/NewServicePage';
import EditServicePage from './pages/EditServicePage';
import ArticleListPage from './pages/ArticleListPage';
import NewArticlePage from './pages/NewArticlePage';
import EditArticlePage from './pages/EditArticlePage';
import InformationListPage from './pages/InformationListPage';
import NewInformationPage from './pages/NewInformationPage';
import EditInformationPage from './pages/EditInformationPage';
import AboutListPage from './pages/AboutListPage';
import EditAboutPage from './pages/EditAboutPage';
import PricingPage from './pages/PricingPage';
import ReferenceListPage from './pages/ReferenceListPage';
import EditReferencePage from './pages/EditReferencePage';
import NewReferencePage from './pages/NewReferencePage';
import EmployeeListPage from './pages/EmployeeListPage';
import NewEmployeePage from './pages/NewEmployeePage';
import EditEmployessPage from './pages/EditEmployessPage';
import ContactListPage from './pages/ContactListPage';
import EditContactPage from './pages/EditContactPage';
import BasicPageList from './pages/BasicPageList';
import EditBasicPage from './pages/EditBasicPage';
import Signin from './pages/Signin';
import Callback from './pages/Callback';
import NewBasicPage from './pages/NewBasicPage';
import requireAuth from './services/auth/requireAuth';

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={requireAuth(Dashboard)} />
          <Route
            exact
            path="/homepage"
            component={requireAuth(HpSettingsPage)}
          />
          <Route
            exact
            path="/sluzby"
            component={requireAuth(ServiceListPage)}
          />
          <Route
            exact
            path="/sluzby/new"
            component={requireAuth(NewServicePage)}
          />
          <Route
            exact
            path="/sluzby/edit/:id/:lang"
            component={requireAuth(EditServicePage)}
          />
          <Route
            exact
            path="/clanky"
            component={requireAuth(ArticleListPage)}
          />
          <Route
            exact
            path="/clanky/new"
            component={requireAuth(NewArticlePage)}
          />
          <Route
            exact
            path="/clanky/edit/:id/:lang"
            component={requireAuth(EditArticlePage)}
          />
          <Route
            exact
            path="/informace"
            component={requireAuth(InformationListPage)}
          />
          <Route
            exact
            path="/informace/new"
            component={requireAuth(NewInformationPage)}
          />
          <Route
            exact
            path="/informace/edit/:id/:lang"
            component={requireAuth(EditInformationPage)}
          />
          <Route
            exact
            path="/oklinice"
            component={requireAuth(AboutListPage)}
          />
          <Route
            exact
            path="/oklinice/edit/:id/:lang"
            component={requireAuth(EditAboutPage)}
          />
          <Route
            exact
            path="/reference"
            component={requireAuth(ReferenceListPage)}
          />
          <Route
            exact
            path="/reference/edit/:id/:lang"
            component={requireAuth(EditReferencePage)}
          />
          <Route
            exact
            path="/reference/new"
            component={requireAuth(NewReferencePage)}
          />
          <Route
            exact
            path="/zamestnanci"
            component={requireAuth(EmployeeListPage)}
          />
          <Route
            exact
            path="/zamestnanci/new"
            component={requireAuth(NewEmployeePage)}
          />
          <Route
            exact
            path="/zamestnanci/edit/:id/:lang"
            component={requireAuth(EditEmployessPage)}
          />
          <Route
            exact
            path="/kontakt"
            component={requireAuth(ContactListPage)}
          />
          <Route
            exact
            path="/kontakt/edit/:id/:lang"
            component={requireAuth(EditContactPage)}
          />
          <Route
            exact
            path="/zakladni-stranky"
            component={requireAuth(BasicPageList)}
          />
          <Route
            exact
            path="/zakladni-stranky/new"
            component={requireAuth(NewBasicPage)}
          />
          <Route
            exact
            path="/zakladni-stranky/edit/:id/:lang"
            component={requireAuth(EditBasicPage)}
          />
          <Route exact path="/cenik" component={requireAuth(PricingPage)} />
          <Route path="/prihlaseni" component={Signin} />
          <Route path="/callback" component={Callback} />
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js